export const API_URL = "https://api.rynarzewozamosc.pl"; // "http://127.0.0.1:1337";
